import { render, staticRenderFns } from "./DocumentsVault.vue?vue&type=template&id=4f6ea779&scoped=true&"
import script from "./DocumentsVault.vue?vue&type=script&lang=js&"
export * from "./DocumentsVault.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsVault.vue?vue&type=style&index=0&id=4f6ea779&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ea779",
  null
  
)

export default component.exports